<template>
    <div class="content" v-html="content"></div>
</template>

<script setup>

const props = defineProps({
    content: {
        type: String,
        required: true
    }
})
</script>

<style lang="scss" >
.content {
    // Ajoutez ici vos styles SCSS
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.6;
    max-width: 900px;
    margin: 0 auto;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50vw;
        width: 50vw;
        transform: translateX(20%);
        aspect-ratio: 8 / 7;
        border-radius: 791px;
        opacity: 0.3;
        filter: blur(150px);
        pointer-events: none;
    }

    &:after{
        content: '';
        position: absolute;
        background-image: url(/images/text-section-stars.webp);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        top: 100vh;
        left: -50%;
        width: 65vw;
        aspect-ratio: 16 / 10;
        transform: translate(-50%, 0);
        z-index: -3;
    }

    & h2{
        margin: 50px 0 25px;
        font-size: 40px;
    }

    & table {
        width: 100%;
        border-collapse: collapse;
        margin: 2rem 0;
        border-radius: 8px;
        border: 1px solid $text-color--blue;
    }

    & th, & td {
        padding: 1rem;
        text-align: left;
        border: 1px solid $text-color--blue;
    }

    & th {
        font-weight: bold;
    }

    & tbody tr:last-child td {
        border-bottom: none;
    }
}
</style>